import {
  adaptPayload,
  prepareFilterSchema,
} from "@utils/adaptedpayloadExplore";
import { useRouter } from "next/router";
import { EXPLORE_SLUG } from "types/api/explore";
import { ExploreInputDT } from "./types";
import newExploreApi from "@api/new-explore";
import { exploreMethodBySlug } from "types/api/new-explore";
import { ExploreStore, useExploreStore } from "./useExloreStore";
import { getProductData } from "./helpers";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";

const useExplorePreloadedData = () => {
  const { query } = useRouter() || {};

  const slug =
    typeof query.slug === "string"
      ? (query.slug as EXPLORE_SLUG)
      : EXPLORE_SLUG.COURSE;
  const payload = adaptPayload(query);

  const {
    data: exploreData,
    error: exploreError,
    isLoading,
  } = useRequestImmutable(
    newExploreApi[exploreMethodBySlug[slug]](payload) as ExploreInputDT
  );
  const { data: categoryData } = useRequestImmutable(
    newExploreApi.getCategory()
  );

  const preloaded: Partial<ExploreStore> = {
    paginationData: exploreData?.pagination || undefined,
    filtersData: prepareFilterSchema(payload, slug),
    categoryData: exploreData?.filters ? categoryData?.data : undefined,
    count: 24,
    exploreError,
  };

  const exploreStoreState = useExploreStore((s) => s, preloaded);
  return {
    ...exploreStoreState,
    productData: getProductData(exploreData, slug),
    isLoading: isLoading,
  };
};

export default useExplorePreloadedData;
